module.exports = __webpack_public_path__ + "public/img/chanliang_1.fa9cb16e.png";